import Search  from "../components/Search";
import Banner from "../components/Banner";
import BestFoodItems from "../components/BestFoodItems";
import OfferSection from "../components/OfferSection";
import HomeAbout from "../components/HomeAbout";
import PopularDishes from "./PopularDishes";
import ProductModal from "./ProductModal";
import CTASection from "./CTASection";
import FoodMenuSection from "./FoodMenuSection";
import TimerSection from "./TimerSection";
import ChefeSection from "./ChefeSection";
import TestimonialSection from "./TestimonialSection";  
import Blog from "./Blog";

const Home = () => {
  return (
    <div>  
        
        <Search />  
        <Banner />
        <BestFoodItems />
         <HomeAbout />
        {/* <OfferSection /> */}
        <PopularDishes />
       
        <ProductModal />
        {/* <CTASection /> */}
        <FoodMenuSection />
        {/* <TimerSection />   */}
        {/* <ChefeSection /> */}
        {/* <TestimonialSection /> */}
        {/* <Blog /> */}
       
    </div>
  );
}
export default Home;